module.exports = __webpack_public_path__ + "static/media/select-service.f2f38a94.svg";